import React from 'react'
import styled from '@emotion/styled'

const SVG = styled.svg`
  padding: 0;
  width: 40px;
`

const SectionIcon = props => {
  return (
    <SVG viewBox="0 0 40 45">
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="HOME-PAGE"
          transform="translate(-1159.000000, -1683.000000)"
          fill="#1E1210"
        >
          <g id="simbol" transform="translate(1159.000000, 1683.000000)">
            <path
              d="M19.9131386,42.3111111 L2.53164557,32.4820678 L2.53164557,12.8170885 L19.9131386,2.98666667 L35.9493671,12.0533732 L19.237692,21.5019374 C19.1377822,21.5584579 19.0491298,21.6273852 18.9703277,21.7045839 C18.964699,21.7100981 18.9576631,21.7142337 18.9520343,21.7197479 C18.8450886,21.8258961 18.7662865,21.9527224 18.700149,22.0864415 C18.6832629,22.1222838 18.6691911,22.1567475 18.6551193,22.1939682 C18.6002392,22.3387157 18.5622453,22.4903559 18.5622453,22.6530245 L18.5622453,31.5846334 C18.5622453,32.3125065 19.1631114,32.9107961 19.9131386,32.9107961 C20.6603514,32.9107961 21.265439,32.3125065 21.265439,31.5846334 L21.265439,24.9441704 L35.9451455,33.2471617 L19.9131386,42.3111111 Z M22.7848101,22.6516158 L36.9620253,14.4355556 L36.9620253,30.8622222 L22.7848101,22.6516158 Z M40,11.859126 C40,11.8248412 39.9887908,11.7905564 39.9859885,11.7562715 C39.9817851,11.7151297 39.9761805,11.6767307 39.9691747,11.6369603 C39.9425529,11.4874784 39.8991173,11.3448534 39.8248564,11.2145711 C39.8220541,11.2104569 39.8220541,11.2063427 39.8192518,11.2022285 C39.8178506,11.1994857 39.8150483,11.1981143 39.8136472,11.1953715 C39.736584,11.0664605 39.6314978,10.9581205 39.5124002,10.8607515 C39.4759703,10.8305809 39.4409416,10.803153 39.4017094,10.7784679 C39.3750876,10.7592684 39.3526692,10.7359547 39.3246462,10.719498 L20.6711503,0.178966863 C20.2550091,-0.059655621 19.7407874,-0.059655621 19.3274485,0.178966863 L0.672551492,10.719498 C0.257811405,10.9553777 0,11.3859953 0,11.859126 L0,32.942931 C0,33.4119477 0.257811405,33.8480508 0.672551492,34.0811877 L19.3274485,44.6244616 C19.5320163,44.7396587 19.7660081,44.8 20,44.8 C20.2297884,44.8 20.4665826,44.7396587 20.6711503,44.6244616 L39.3246462,34.0811877 C39.3778899,34.0523885 39.4199243,34.0098753 39.4689646,33.974219 C39.5124002,33.9413056 39.5614404,33.9138777 39.6006726,33.8741073 C39.6483116,33.8288513 39.6833403,33.7726242 39.7239737,33.7205112 C39.7547989,33.6793694 39.79263,33.6450846 39.8192518,33.5998286 C39.8234552,33.594343 39.8220541,33.587486 39.8262575,33.5820005 C39.9005184,33.4530895 39.943954,33.3104645 39.9691747,33.162354 C39.9761805,33.1225836 39.9817851,33.0841846 39.9859885,33.0444142 C39.9887908,33.0101293 40,32.9772159 40,32.942931 L40,11.859126 Z"
              id="Fill-6"
            ></path>
          </g>
        </g>
      </g>
    </SVG>
  )
}

export default SectionIcon
